

export async function delay(ms) {

    return new Promise(resolve =>{
         setTimeout(resolve, ms)
    })
}

export function randomInt(min, max) {
    return Math.floor(Math.random() * (parseInt(max) - parseInt(min) + 1)) + parseInt(min);
}
export function getArrayDiff(arr1, arr2, key = null) {
    let set;
    if (key) {
        set = new Set(arr2.map(item => item[key]));
        return arr1.filter(item => !set.has(item[key]));
    } else {
        set = new Set(arr2);
        return arr1.filter(item => !set.has(item));
    }
}


export function tsToTime(ts) {
    let num = Number(ts);
    // 10位秒级 → 转毫秒
    if (num.toString().length === 10) {
        num = num * 1000;
    }
    const d = new Date(num);
    // 补0工具
    const pad = n => String(n).padStart(2, '0');
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1); // 月份0开始，+1
    const day = pad(d.getDate());
    const h = pad(d.getHours());
    const m = pad(d.getMinutes());
    const s = pad(d.getSeconds());
    return `${year}-${month}-${day} ${h}:${m}:${s}`;
}